module.exports = __webpack_public_path__ + "img/product_chart_8.d21f36ad.png";